import { all, takeEvery, put, fork, call } from "redux-saga/effects";

import { selectStoreService } from "@iso/services";
import actions from "@iso/redux/selectStore/actions";

function* getStores() {
  yield takeEvery(actions.FETCH_STORES_REQUEST, function* ({ payload }) {
    try {
      const responseSelectStore = yield call(
        selectStoreService.fetchStores,
        payload || {}
      );
      const stores = responseSelectStore?.stores || [];
      for (const store of stores) {
        if (store.teams !== null && store.teams !== undefined) {
          store.teams = store.teams.split(",").map(item => {
            const parsed = Number(item)
            return isNaN(parsed) ? item : parsed;
          })
        } else {
          store.teams = []
        }
      }

      yield put({
        type: actions.FETCH_STORES_SUCCESS,
        stores,
      });
    } catch (error) {
      yield put({
        type: actions.FETCH_STORES_ERROR,
        error: error.response,
      });
    }
  });
}

function* getSelectStoreMetaData() {
  yield takeEvery(actions.FETCH_METADATA_SELECT_STORE_REQUEST, function* () {
    try {
      const metaData = yield all([
        call(selectStoreService.fetchAdInCharges, { currentDirector: null }),
        call(selectStoreService.fetchChains),
      ]);
      yield put({
        type: actions.FETCH_METADATA_SELECT_STORE_SUCCESS,
        directors: metaData[0].accounts,
        chains: metaData[1].chains,
      });
    } catch (error) {
      yield put({
        type: actions.FETCH_METADATA_SELECT_STORE_ERROR,
        error: error.response,
      });
    }
  });
}

export default function* rootSaga() {
  yield all([fork(getStores), fork(getSelectStoreMetaData)]);
}
